<template>
  <div>
    <InvitationForm />

    <section class="search">
      <div class="ns-container">
        <div class="row">
          <TableServer :options="options" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    InvitationForm: () => import('@/components/admin/InvitationForm'),
    TableServer: () => import('@/components/_vue/TableServer'),
  },

  data() {
    return {
      options: {
        url: '/api/admin/invitations',
        name: 'invitations',
        columns: ['id', 'for', 'code', 'emailCreatedAt', 'emailSentAt', 'userCreatedAt', 'userId', 'userName', 'backerId', 'backerName', 'createdAt'],
        tableOptions: {
          perPage: 100,
        },
      },
    };
  },
};
</script>
